import type { Action } from 'redux';
import NotificationActions from '../../../../main/actions/NotificationActions';
import { AdLinkEditorService } from '../../../../main/services/AdLinkEditorService/AdLinkEditorService';
import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';

const ArchiveAdLink = new ReduxAsyncAction<'ARCHIVE_AD_LINK', { adLinkId: string; archived: boolean }, Record<string, any>>(
  'ARCHIVE_AD_LINK'
);

ArchiveAdLink.registerRequest(async ({ adLinkId, archived }): Promise<Record<string, any>> => {
  try {
    const { data } = await dash_api.get(`/v1/linkhub/ad/${adLinkId}`);

    const payload = AdLinkEditorService.getAdLinkPayload(data);

    const response = await dash_api.put(`/v1/linkhub/ad/${adLinkId}/${archived}`, payload);

    return response;
  } catch (error) {
    NotificationActions.showNotification('Failed to archive ad link.', 'error');

    throw error;
  }
});

export const ARCHIVE_AD_LINK = ArchiveAdLink.actionNamespaceConstants;
export const archiveAdLink = ArchiveAdLink.request;

export type ArchiveAdLinkResponseAction = Action<typeof ARCHIVE_AD_LINK.response> & {
  data: Record<string, any>;
};
